









































































































  





























  











    





















      









































































    










    



    



    



    



















      


      

      




          










      






      























    











      





      




















    





    





    













      




      



      

































      




      












    




    




    













      











      






      

      




      
















      

      



      






































































































































            



























            



























            















            










































































































                          





                          




























































































































































            









































































            



































            












































import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import axios from 'axios';
import "../rest/UserManagement.css";
import {
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  IconButton,
  Tooltip,
  CircularProgress,
  Box,
  TextField,
  InputAdornment,
  Chip,
  FormControlLabel,
  Switch,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox
} from '@mui/material';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon,
  Person as PersonIcon,
  Save as SaveIcon,
  Close as CloseIcon,
  Discount as DiscountIcon,
  Business as BusinessIcon,
  Block as BlockIcon,
  Restore as RestoreIcon,
  Clear as ClearIcon,
  Warning as WarningIcon,
  LocationCity as LocationCityIcon,
  SwapHoriz as SwapIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import debounce from 'lodash/debounce';

const StyledContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(3),
  maxWidth: '1400px',
  margin: '0 auto',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  backgroundColor: '#f9fafc',
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

const EditButton = styled(IconButton)(({ theme }) => ({
  color: '#3f51b5',
  '&:hover': {
    backgroundColor: '#e8eaf6',
  },
}));

const DeleteButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#ff4444',
  color: 'white',
  '&:hover': {
    backgroundColor: '#cc0000',
  },
}));

const SaveButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#4CAF50',
  color: 'white',
  '&:hover': {
    backgroundColor: '#45a049',
  },
}));

const DeactivateButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#ff9800',
  color: 'white',
  '&:hover': {
    backgroundColor: '#e68900',
  },
}));

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [contractorFilter, setContractorFilter] = useState('');
  const [cityFilter, setCityFilter] = useState('');
  const [showDeactivated, setShowDeactivated] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [discountDialogOpen, setDiscountDialogOpen] = useState(false);
  const [cityDialogOpen, setCityDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editFormData, setEditFormData] = useState({
    username: '',
    email: '',
    token: ''
  });
  const [discountValue, setDiscountValue] = useState(0);
  const [cityValue, setCityValue] = useState('');
  const [editErrors, setEditErrors] = useState({});
  const [discountError, setDiscountError] = useState('');
  const [cityError, setCityError] = useState('');
  const [uniqueContractors, setUniqueContractors] = useState([]);
  const [uniqueCities, setUniqueCities] = useState([]);
  
  
  const [contractorDialogOpen, setContractorDialogOpen] = useState(false);
  const [selectedUserForContractor, setSelectedUserForContractor] = useState(null);
  const [contractorSearch, setContractorSearch] = useState('');
  const [contractorsList, setContractorsList] = useState([]);
  const [filteredContractors, setFilteredContractors] = useState([]);
  const [showContractorDropdown, setShowContractorDropdown] = useState(false);
  const [selectedContractorId, setSelectedContractorId] = useState(null);
  const [loadingContractors, setLoadingContractors] = useState(false);
  const [contractorError, setContractorError] = useState('');
  const contractorRef = useRef(null);
  
  
  const [citySearch, setCitySearch] = useState('');
  const [filteredCities, setFilteredCities] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [allCities, setAllCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const cityRef = useRef(null);

  
  const [bulkActionDialogOpen, setBulkActionDialogOpen] = useState(false);
  const [bulkActionType, setBulkActionType] = useState('');
  const [bulkActionUsers, setBulkActionUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [bulkSelectAll, setBulkSelectAll] = useState(false);

  
  const [deactivateCompanyDialogOpen, setDeactivateCompanyDialogOpen] = useState(false);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [contractorUsers, setContractorUsers] = useState([]);

  
  const fetchAllCities = useCallback(async () => {
    if (allCities.length > 0) return;
    
    setLoadingCities(true);
    try {
      const response = await axios.get('https://test2.planfix-to-syrve.com/api/all-cities');
      if (response.data.success) {
        setAllCities(response.data.data);
      }
    } catch (error) {
      console.error('Помилка завантаження міст:', error);
    } finally {
      setLoadingCities(false);
    }
  }, [allCities.length]);

  
  const debouncedSearchCities = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim() === '') {
        setFilteredCities([]);
        setShowCityDropdown(false);
        return;
      }
      
      try {
        const response = await axios.get(`https://test2.planfix-to-syrve.com/api/cities?search=${encodeURIComponent(searchTerm)}`);
        if (response.data.success) {
          setFilteredCities(response.data.data);
          setShowCityDropdown(response.data.data.length > 0);
        }
      } catch (error) {
        console.error('Помилка пошуку міст:', error);
      }
    }, 300),
    []
  );

  

  
  const fetchContractors = useCallback(async (search = '') => {
    try {
      setLoadingContractors(true);
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/search-contractors`, {
        params: { search: search }
      });
      if (response.data.success) {
        setContractorsList(response.data.data);
        setFilteredContractors(response.data.data);
      }
    } catch (error) {
      console.error('Помилка завантаження компаній:', error);
    } finally {
      setLoadingContractors(false);
    }
  }, []);

  
  const debouncedSearchContractors = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim() === '') {
        await fetchContractors('');
        setShowContractorDropdown(false);
        return;
      }
      
      try {
        const response = await axios.get(`https://test2.planfix-to-syrve.com/api/search-contractors`, {
          params: { search: searchTerm.trim() }
        });
        if (response.data.success) {
          setFilteredContractors(response.data.data);
          setShowContractorDropdown(response.data.data.length > 0);
        }
      } catch (error) {
        console.error('Помилка пошуку компаній:', error);
      }
    }, 300),
    []
  );

  
  const handleContractorClick = useCallback((user) => {
    setSelectedUserForContractor(user);
    setSelectedContractorId(user.contractor_id || null);
    setContractorSearch(user.contractor_name || '');
    setContractorError('');
    setContractorDialogOpen(true);
    fetchContractors('');
  }, [fetchContractors]);

  
  const handleContractorSearchChange = (e) => {
    const value = e.target.value;
    setContractorSearch(value);
    debouncedSearchContractors(value);
    if (contractorError) setContractorError('');
  };

  
  const handleContractorSelect = (contractor) => {
    setContractorSearch(contractor.name);
    setSelectedContractorId(contractor.id);
    setShowContractorDropdown(false);
    if (contractorError) setContractorError('');
  };

  
  const handleContractorSave = async () => {
    if (!selectedContractorId) {
      setContractorError('Виберіть компанію зі списку');
      return;
    }

    try {
      const response = await axios.put('https://test2.planfix-to-syrve.com/api/update-user-contractor', {
        user_id: selectedUserForContractor.id,
        contractor_id: selectedContractorId
      });

      if (response.data.success) {
        setSuccess(`Компанію для "${selectedUserForContractor.username?.replace('_deactivated', '')}" успішно змінено`);
        setContractorDialogOpen(false);
        setSelectedUserForContractor(null);
        setSelectedContractorId(null);
        setContractorSearch('');
        fetchUsers();
        setTimeout(() => setSuccess(''), 3000);
      }
    } catch (error) {
      console.error('Error updating contractor:', error);
      setContractorError(error.response?.data?.message || 'Помилка при зміні компанії');
    }
  };

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (contractorRef.current && !contractorRef.current.contains(event.target)) {
        setShowContractorDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  
  const handleCitySearchChange = (e) => {
    const value = e.target.value;
    setCityValue(value);
    setCitySearch(value);
    debouncedSearchCities(value);
    if (cityError) setCityError('');
  };

  
  const handleCitySelect = (selectedCity) => {
    setCityValue(selectedCity);
    setCitySearch(selectedCity);
    setShowCityDropdown(false);
    if (cityError) setCityError('');
  };

  
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
    if (editErrors[name]) {
      setEditErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cityRef.current && !cityRef.current.contains(event.target)) {
        setShowCityDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  
  const memoizedUniqueContractors = useMemo(() => {
    return [...new Map(
      users.filter(u => u.contractor_name)
        .map(u => [u.contractor_id, { id: u.contractor_id, name: u.contractor_name }])
    ).values()];
  }, [users]);

  const memoizedUniqueCities = useMemo(() => {
    return [...new Set(
      users.filter(u => u.city && u.city.trim())
        .map(u => u.city.trim())
    )];
  }, [users]);

  useEffect(() => {
    setUniqueContractors(memoizedUniqueContractors);
    setUniqueCities(memoizedUniqueCities);
  }, [memoizedUniqueContractors, memoizedUniqueCities]);

  
  const memoizedFilteredUsers = useMemo(() => {
    let filtered = [...users];
    
    if (searchTerm.trim() !== '') {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(user =>
        user.username?.replace('_deactivated', '').toLowerCase().includes(searchLower) ||
        user.email?.toLowerCase().includes(searchLower) ||
        user.token?.toLowerCase().includes(searchLower) ||
        user.contractor_name?.toLowerCase().includes(searchLower) ||
        user.city?.toLowerCase().includes(searchLower)
      );
    }
    
    if (contractorFilter) {
      filtered = filtered.filter(user => user.contractor_name === contractorFilter);
    }
    
    if (cityFilter) {
      filtered = filtered.filter(user => user.city === cityFilter);
    }
    
    if (!showDeactivated) {
      filtered = filtered.filter(user => !user.username?.includes('_deactivated'));
    }
    
    return filtered;
  }, [users, searchTerm, contractorFilter, cityFilter, showDeactivated]);

  useEffect(() => {
    setFilteredUsers(memoizedFilteredUsers);
  }, [memoizedFilteredUsers]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const [contractorsResponse, usersResponse] = await Promise.all([
        axios.get('https://test2.planfix-to-syrve.com/contractors'),
        axios.get('https://test2.planfix-to-syrve.com/users-admin')
      ]);
      
      const contractors = contractorsResponse.data;
      const users = usersResponse.data;
      
      const userContractorMap = new Map();
      
      await Promise.all(contractors.map(async (contractor) => {
        try {
          const contractorUsersResponse = await axios.get(`https://test2.planfix-to-syrve.com/contractor-users/${contractor.id}`);
          const contractorUsers = contractorUsersResponse.data;
          
          for (const user of contractorUsers) {
            userContractorMap.set(user.id, {
              contractor_id: contractor.id,
              contractor_name: contractor.name
            });
          }
        } catch (err) {
          console.error(`Error fetching users for contractor ${contractor.id}:`, err);
        }
      }));
      
      const usersWithContractors = users.map(user => ({
        ...user,
        contractor_id: userContractorMap.get(user.id)?.contractor_id || null,
        contractor_name: userContractorMap.get(user.id)?.contractor_name || null,
        is_active: !user.username?.includes('_deactivated') ? 1 : 0
      }));
      
      setUsers(usersWithContractors);
    } catch (error) {
      setError('Помилка при завантаженні користувачів');
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  

  
  const openBulkActionDialog = (actionType, initialUsers = []) => {
    let availableUsers;
    
    if (actionType === 'deactivate') {
      availableUsers = filteredUsers.filter(u => !u.username?.includes('_deactivated'));
    } else {
      availableUsers = filteredUsers.filter(u => u.username?.includes('_deactivated'));
    }
    
    if (availableUsers.length === 0) {
      setError(actionType === 'deactivate' 
        ? 'Немає активних користувачів для деактивації' 
        : 'Немає деактивованих користувачів для активації'
      );
      return;
    }
    
    const initialSelected = initialUsers.length > 0 
      ? availableUsers.filter(u => initialUsers.some(init => init.id === u.id))
      : [];
    
    setBulkActionUsers(availableUsers);
    setSelectedUsers(initialSelected.map(u => u.id));
    setBulkActionType(actionType);
    setBulkSelectAll(initialSelected.length === availableUsers.length);
    setBulkActionDialogOpen(true);
  };

  
  const handleBulkSelectUser = (userId) => {
    setSelectedUsers(prev => {
      if (prev.includes(userId)) {
        return prev.filter(id => id !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };

  
  const handleBulkSelectAll = () => {
    if (bulkSelectAll) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(bulkActionUsers.map(u => u.id));
    }
    setBulkSelectAll(!bulkSelectAll);
  };

  
  const handleBulkActionConfirm = async () => {
    if (selectedUsers.length === 0) {
      setError('Виберіть хоча б одного користувача');
      return;
    }

    const userIds = selectedUsers;
    
    try {
      if (bulkActionType === 'deactivate') {
        await axios.post('https://test2.planfix-to-syrve.com/api/admin/deactivate-multiple-users', {
          user_ids: userIds,
          admin_user_id: 1
        });
        setSuccess(`Деактивовано ${userIds.length} користувачів`);
      } else if (bulkActionType === 'activate') {
        await axios.post('https://test2.planfix-to-syrve.com/api/admin/activate-multiple-users', {
          user_ids: userIds,
          admin_user_id: 1
        });
        setSuccess(`Активовано ${userIds.length} користувачів`);
      }
      
      await fetchUsers();
      setBulkActionDialogOpen(false);
      setSelectedUsers([]);
      setBulkSelectAll(false);
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при виконанні дії');
    }
  };

  

  const handleDeactivateCompanyClick = (user) => {
    if (!user.contractor_id) {
      setError('Цей користувач не прив\'язаний до жодної компанії');
      return;
    }
    
    const usersOfContractor = users.filter(u => 
      u.contractor_id === user.contractor_id && 
      !u.username?.includes('_deactivated')
    );
    
    if (usersOfContractor.length === 0) {
      setError('Немає активних користувачів для деактивації');
      return;
    }
    
    setSelectedContractor({
      id: user.contractor_id,
      name: user.contractor_name
    });
    setContractorUsers(usersOfContractor);
    setDeactivateCompanyDialogOpen(true);
  };

  const handleDeactivateCompanyConfirm = async () => {
    try {
      const userIds = contractorUsers.map(u => u.id);
      
      await axios.post('https://test2.planfix-to-syrve.com/api/admin/deactivate-contractor-users', {
        contractor_id: selectedContractor.id,
        contractor_name: selectedContractor.name,
        user_ids: userIds,
        admin_user_id: 1
      });
      
      await fetchUsers();
      
      setSuccess(`Деактивовано ${userIds.length} користувачів контрагента "${selectedContractor.name}"`);
      setDeactivateCompanyDialogOpen(false);
      setSelectedContractor(null);
      setContractorUsers([]);
      
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при деактивації користувачів');
    }
  };

  

  const handleDeactivateSingleUser = (user) => {
    openBulkActionDialog('deactivate', [user]);
  };

  const handleActivateSingleUser = (user) => {
    openBulkActionDialog('activate', [user]);
  };

  

  const handleCityClick = useCallback((user) => {
    setSelectedUser(user);
    setCityValue(user.city || '');
    setCitySearch(user.city || '');
    setCityError('');
    setCityDialogOpen(true);
    fetchAllCities();
  }, [fetchAllCities]);

  const handleCitySave = useCallback(async () => {
    if (!cityValue.trim()) {
      setCityError('Місто не може бути порожнім');
      return;
    }
    
    if (cityValue.length < 2) {
      setCityError('Назва міста має містити мінімум 2 символи');
      return;
    }

    try {
      await axios.put(`https://test2.planfix-to-syrve.com/update-city/${selectedUser.id}`, {
        city: cityValue.trim()
      });

      await fetchUsers();
      
      setSuccess(`Місто для "${selectedUser.username?.replace('_deactivated', '')}" оновлено на "${cityValue.trim()}"`);
      setCityDialogOpen(false);
      setSelectedUser(null);
      setCityValue('');
      setCitySearch('');
      
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error updating city:', error);
      setCityError(error.response?.data?.message || 'Помилка при оновленні міста');
    }
  }, [cityValue, selectedUser, fetchUsers]);

  const handleEditClick = useCallback((user) => {
    setSelectedUser(user);
    setEditFormData({
      username: user.username?.replace('_deactivated', '') || '',
      email: user.email || '',
      token: user.token || ''
    });
    setEditErrors({});
    setEditDialogOpen(true);
  }, []);

  const handleEditSave = useCallback(async () => {
    const errors = {};
    
    if (!editFormData.username.trim()) {
      errors.username = "Ім'я користувача обов'язкове";
    } else if (editFormData.username.length < 3) {
      errors.username = "Ім'я має містити мінімум 3 символи";
    }
    
    if (!editFormData.email.trim()) {
      errors.email = "Email обов'язковий";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editFormData.email)) {
      errors.email = "Невірний формат email";
    }
    
    if (Object.keys(errors).length > 0) {
      setEditErrors(errors);
      return;
    }

    try {
      await axios.put(`https://test2.planfix-to-syrve.com/users/${selectedUser.id}`, {
        username: editFormData.username.trim(),
        email: editFormData.email.trim().toLowerCase(),
        token: editFormData.token.trim() || null
      });

      await fetchUsers();
      
      setSuccess(`Користувача "${editFormData.username}" успішно оновлено`);
      setEditDialogOpen(false);
      setSelectedUser(null);
      setEditFormData({ username: '', email: '', token: '' });
      
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error updating user:', error);
      
      if (error.response?.status === 409) {
        if (error.response.data.field === 'email') {
          setEditErrors({ email: 'Користувач з таким email вже існує' });
        } else if (error.response.data.field === 'username') {
          setEditErrors({ username: 'Користувач з таким іменем вже існує' });
        } else {
          setError(error.response.data.message || 'Помилка при оновленні користувача');
        }
      } else {
        setError(error.response?.data?.message || 'Помилка при оновленні користувача');
      }
    }
  }, [editFormData, selectedUser, fetchUsers]);

  const handleDiscountClick = useCallback((user) => {
    setSelectedUser(user);
    setDiscountValue(parseFloat(user.discount) || 0);
    setDiscountError('');
    setDiscountDialogOpen(true);
  }, []);

  const handleDiscountSave = useCallback(async () => {
    if (discountValue < 0 || discountValue > 100) {
      setDiscountError('Знижка має бути від 0 до 100');
      return;
    }

    try {
      await axios.put(`https://test2.planfix-to-syrve.com/update-discount/${selectedUser.id}`, {
        discount: discountValue
      });

      await fetchUsers();
      
      setSuccess(`Знижку для "${selectedUser.username?.replace('_deactivated', '')}" успішно оновлено до ${discountValue}%`);
      setDiscountDialogOpen(false);
      setSelectedUser(null);
      setDiscountValue(0);
      
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error updating discount:', error);
      setDiscountError(error.response?.data?.message || 'Помилка при оновленні знижки');
    }
  }, [discountValue, selectedUser, fetchUsers]);

  const handleDeleteClick = useCallback((user) => {
    setSelectedUser(user);
    setDeleteDialogOpen(true);
  }, []);

  const handleDeleteConfirm = useCallback(async () => {
    if (!selectedUser) return;

    try {
      await axios.delete(`https://test2.planfix-to-syrve.com/users/${selectedUser.id}`);
      
      setUsers(prevUsers => prevUsers.filter(user => user.id !== selectedUser.id));
      
      setSuccess(`Користувача "${selectedUser.username?.replace('_deactivated', '')}" успішно видалено`);
      setSelectedUser(null);
      setDeleteDialogOpen(false);
      
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при видаленні користувача');
    }
  }, [selectedUser]);

  const handleCloseDialog = useCallback(() => {
    setDeleteDialogOpen(false);
    setEditDialogOpen(false);
    setDiscountDialogOpen(false);
    setCityDialogOpen(false);
    setBulkActionDialogOpen(false);
    setDeactivateCompanyDialogOpen(false);
    setContractorDialogOpen(false);
    setSelectedUser(null);
    setSelectedContractor(null);
    setSelectedUserForContractor(null);
    setContractorUsers([]);
    setSelectedUsers([]);
    setBulkSelectAll(false);
    setEditFormData({ username: '', email: '', token: '' });
    setDiscountValue(0);
    setCityValue('');
    setCitySearch('');
    setContractorSearch('');
    setSelectedContractorId(null);
    setEditErrors({});
    setDiscountError('');
    setCityError('');
    setContractorError('');
    setShowCityDropdown(false);
    setShowContractorDropdown(false);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const handleContractorFilterChange = useCallback((event) => {
    setContractorFilter(event.target.value);
  }, []);

  const handleCityFilterChange = useCallback((event) => {
    setCityFilter(event.target.value);
  }, []);

  const clearContractorFilter = useCallback(() => {
    setContractorFilter('');
  }, []);

  const clearCityFilter = useCallback(() => {
    setCityFilter('');
  }, []);

  const getDiscountColor = useCallback((discount) => {
    const value = parseFloat(discount) || 0;
    if (value === 0) return 'default';
    if (value < 10) return 'success';
    if (value < 20) return 'primary';
    if (value < 30) return 'warning';
    return 'error';
  }, []);

  const getStats = useMemo(() => {
    const activeCount = users.filter(u => !u.username?.includes('_deactivated')).length;
    const deactivatedCount = users.filter(u => u.username?.includes('_deactivated')).length;
    return {
      total: users.length,
      withDiscount: users.filter(u => u.discount && parseFloat(u.discount) > 0).length,
      active: activeCount,
      deactivated: deactivatedCount,
      contractors: uniqueContractors.length,
      cities: uniqueCities.length
    };
  }, [users, uniqueContractors.length, uniqueCities.length]);

  const renderUsername = useCallback((user) => {
    const isDeactivated = user.username?.includes('_deactivated');
    const displayName = user.username?.replace('_deactivated', '');
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <PersonIcon color={isDeactivated ? 'disabled' : 'action'} />
        <Typography 
          variant="body2" 
          fontWeight="medium"
          sx={{
            textDecoration: isDeactivated ? 'line-through' : 'none',
            color: isDeactivated ? '#999' : 'inherit'
          }}
        >
          {displayName}
        </Typography>
        {isDeactivated && (
          <Chip label="Деактивовано" size="small" color="error" variant="outlined" />
        )}
      </Box>
    );
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <StyledContainer maxWidth="xl">
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          sx={{ mb: 3 }}
          onClose={() => error ? setError('') : setSuccess('')}
        >
          {error || success}
        </Alert>
      )}

      <StyledPaper>
        <HeaderBox>
          <Box>
            <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#2c3e50' }}>
              <PersonIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
              Управління користувачами
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
              Всього: {getStats.total} | Активні: {getStats.active} | Деактивовані: {getStats.deactivated} | 
              Зі знижками: {getStats.withDiscount} | Компаній: {getStats.contractors} | Міст: {getStats.cities}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={showDeactivated}
                  onChange={(e) => setShowDeactivated(e.target.checked)}
                  color="primary"
                />
              }
              label="Показувати деактивованих"
            />
            
            <TextField
              select
              value={contractorFilter}
              onChange={handleContractorFilterChange}
              variant="outlined"
              size="small"
              sx={{ width: '200px' }}
              SelectProps={{
                native: true,
              }}
              InputProps={{
                endAdornment: contractorFilter && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={clearContractorFilter}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            >
              <option value="">Всі компанії</option>
              {uniqueContractors.map(contractor => (
                <option key={contractor.id} value={contractor.name}>
                  {contractor.name}
                </option>
              ))}
            </TextField>
            
            <TextField
              select
              value={cityFilter}
              onChange={handleCityFilterChange}
              variant="outlined"
              size="small"
              sx={{ width: '180px' }}
              SelectProps={{
                native: true,
              }}
              InputProps={{
                endAdornment: cityFilter && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={clearCityFilter}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            >
              <option value="">Всі міста</option>
              {uniqueCities.map(city => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </TextField>
            
            <TextField
              placeholder="Пошук за іменем, email, компанією, містом..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ width: { xs: '100%', sm: '350px' } }}
            />
            
            <Tooltip title="Оновити список">
              <Button
                variant="outlined"
                startIcon={<RefreshIcon />}
                onClick={fetchUsers}
              >
                Оновити
              </Button>
            </Tooltip>
          </Box>
        </HeaderBox>

        {}
     

        <TableContainer component={Paper} sx={{ overflowX: 'auto', borderRadius: '8px' }}>
          <Table sx={{ minWidth: { xs: '700px', sm: '1200px' } }}>
            <TableHead sx={{ backgroundColor: '#3f51b5' }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>ID</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Компанія</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Користувач</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Email</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Телефон</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Місто</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Знижка</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Дії</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredUsers.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                    <Typography color="text.secondary">
                      {searchTerm || contractorFilter || cityFilter ? 'Користувачів не знайдено' : 'Користувачів немає'}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredUsers.map((user) => {
                  const isDeactivated = user.username?.includes('_deactivated');
                  return (
                    <TableRow 
                      key={user.id} 
                      sx={{ 
                        '&:nth-of-type(odd)': { backgroundColor: '#f8f9fa' },
                        '&:hover': { backgroundColor: '#e3f2fd' },
                        opacity: isDeactivated ? 0.7 : 1
                      }}
                    >
                      <TableCell>{user.id}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <BusinessIcon color="primary" fontSize="small" />
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              cursor: 'pointer',
                              color: '#1976d2',
                              textDecoration: 'underline',
                              '&:hover': { color: '#0d47a1' }
                            }}
                            onClick={() => handleContractorClick(user)}
                          >
                            {user.contractor_name || '-'}
                          </Typography>
                          {user.contractor_id && (
                            <Tooltip title="Змінити компанію">
                              <IconButton
                                size="small"
                                onClick={() => handleContractorClick(user)}
                                sx={{ padding: '2px' }}
                              >
                                <SwapIcon fontSize="small" color="primary" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {renderUsername(user)}
                      </TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>
                        <Tooltip title={user.token || 'Немає телефону'}>
                          <Typography variant="body2" sx={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {user.token || '-'}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={user.city || 'Місто не вказано'}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              maxWidth: '150px', 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis', 
                              whiteSpace: 'nowrap',
                              cursor: 'pointer',
                              color: user.city ? 'inherit' : '#999'
                            }}
                            onClick={() => handleCityClick(user)}
                          >
                            {user.city || '-'}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={`${user.discount || 0}%`}
                          color={getDiscountColor(user.discount)}
                          size="small"
                          sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                          onClick={() => handleDiscountClick(user)}
                          icon={<DiscountIcon />}
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                          <Tooltip title="Редагувати місто">
                            <IconButton
                              color="info"
                              onClick={() => handleCityClick(user)}
                              size="small"
                            >
                              <LocationCityIcon />
                            </IconButton>
                          </Tooltip>
                          
                          <Tooltip title="Редагувати">
                            <EditButton onClick={() => handleEditClick(user)} size="small">
                              <EditIcon />
                            </EditButton>
                          </Tooltip>
                          
                          {isDeactivated ? (
                            <Tooltip title="Активувати">
                              <IconButton
                                color="success"
                                onClick={() => handleActivateSingleUser(user)}
                                size="small"
                              >
                                <RestoreIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <>
                              <Tooltip title="Деактивувати одного користувача">
                                <IconButton
                                  color="warning"
                                  onClick={() => handleDeactivateSingleUser(user)}
                                  size="small"
                                >
                                  <BlockIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Деактивувати всіх користувачів компанії">
                                <IconButton
                                  color="error"
                                  onClick={() => handleDeactivateCompanyClick(user)}
                                  size="small"
                                  disabled={!user.contractor_id}
                                >
                                  <WarningIcon />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Показано {filteredUsers.length} з {users.length} користувачів
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {searchTerm && `Результати пошуку: "${searchTerm}"`}
            {contractorFilter && ` | Фільтр: ${contractorFilter}`}
            {cityFilter && ` | Місто: ${cityFilter}`}
          </Typography>
        </Box>
      </StyledPaper>

      {}

      {}
      <Dialog open={editDialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          Редагування користувача
          <IconButton onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
            <TextField
              label="Ім'я користувача"
              name="username"
              value={editFormData.username}
              onChange={handleEditChange}
              fullWidth
              required
              error={!!editErrors.username}
              helperText={editErrors.username}
              variant="outlined"
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={editFormData.email}
              onChange={handleEditChange}
              fullWidth
              required
              error={!!editErrors.email}
              helperText={editErrors.email}
              variant="outlined"
            />
            <TextField
              label="Номер телефону"
              name="token"
              value={editFormData.token}
              onChange={handleEditChange}
              fullWidth
              variant="outlined"
              placeholder="Введіть номер телефону (необов'язково)"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">Скасувати</Button>
          <SaveButton onClick={handleEditSave} variant="contained" startIcon={<SaveIcon />}>Зберегти</SaveButton>
        </DialogActions>
      </Dialog>

      {}
      <Dialog open={discountDialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          Встановлення знижки для {selectedUser?.username?.replace('_deactivated', '')}
          <IconButton onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              Виберіть розмір знижки для користувача (0-100%)
            </Typography>
            <TextField
              label="Знижка (%)"
              type="number"
              value={discountValue}
              onChange={(e) => {
                const value = e.target.value === '' ? 0 : Number(e.target.value);
                setDiscountValue(value);
                setDiscountError('');
              }}
              fullWidth
              required
              error={!!discountError}
              helperText={discountError || "Введіть значення від 0 до 100"}
              variant="outlined"
              inputProps={{ min: 0, max: 100, step: 0.5 }}
              autoFocus
            />
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Chip 
                label={`Поточна знижка: ${discountValue}%`}
                color={getDiscountColor(discountValue)}
                sx={{ fontSize: '1rem', p: 2 }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">Скасувати</Button>
          <SaveButton onClick={handleDiscountSave} variant="contained" startIcon={<SaveIcon />}>
            Зберегти знижку {discountValue}%
          </SaveButton>
        </DialogActions>
      </Dialog>

      {}
      <Dialog open={cityDialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          Редагування міста
          <IconButton onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              Користувач: <strong>{selectedUser?.username?.replace('_deactivated', '')}</strong>
            </Typography>
            
            <div ref={cityRef} style={{ position: 'relative' }}>
              <TextField
                label="Місто"
                value={cityValue}
                onChange={handleCitySearchChange}
                onFocus={() => {
                  if (cityValue && allCities.length > 0) {
                    const filtered = allCities.filter(c => 
                      c.toLowerCase().includes(cityValue.toLowerCase())
                    );
                    setFilteredCities(filtered.slice(0, 50));
                    setShowCityDropdown(filtered.length > 0);
                  }
                  fetchAllCities();
                }}
                fullWidth
                required
                error={!!cityError}
                helperText={cityError || "Введіть назву міста або виберіть зі списку"}
                variant="outlined"
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationCityIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              {showCityDropdown && filteredCities.length > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  backgroundColor: 'white',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  marginTop: '4px'
                }}>
                  {filteredCities.map((cityName, index) => (
                    <div
                      key={index}
                      onClick={() => handleCitySelect(cityName)}
                      style={{
                        padding: '8px 12px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f0f0f0',
                        fontSize: '14px',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                      }}
                    >
                      {cityName}
                    </div>
                  ))}
                </div>
              )}
              {loadingCities && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                  <CircularProgress size={20} />
                </Box>
              )}
            </div>
            
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Chip 
                label={`Поточне місто: ${selectedUser?.city || 'не вказано'}`}
                color="primary"
                variant="outlined"
                sx={{ fontSize: '0.9rem', p: 1 }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">Скасувати</Button>
          <SaveButton onClick={handleCitySave} variant="contained" startIcon={<SaveIcon />}>
            Зберегти місто
          </SaveButton>
        </DialogActions>
      </Dialog>

      {}
      <Dialog open={contractorDialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          Зміна компанії
          <IconButton onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              Користувач: <strong>{selectedUserForContractor?.username?.replace('_deactivated', '')}</strong>
            </Typography>
            
            <div ref={contractorRef} style={{ position: 'relative' }}>
              <TextField
                label="Компанія"
                value={contractorSearch}
                onChange={handleContractorSearchChange}
                onFocus={() => {
                  if (contractorSearch && contractorsList.length > 0) {
                    const filtered = contractorsList.filter(c => 
                      c.name.toLowerCase().includes(contractorSearch.toLowerCase())
                    );
                    setFilteredContractors(filtered.slice(0, 50));
                    setShowContractorDropdown(filtered.length > 0);
                  } else {
                    fetchContractors('');
                  }
                }}
                fullWidth
                required
                error={!!contractorError}
                helperText={contractorError || "Введіть назву компанії або виберіть зі списку"}
                variant="outlined"
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              {showContractorDropdown && filteredContractors.length > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  maxHeight: '200px',
                  overflowY: 'auto',
                  backgroundColor: 'white',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  marginTop: '4px'
                }}>
                  {filteredContractors.map((contractor, index) => (
                    <div
                      key={contractor.id || index}
                      onClick={() => handleContractorSelect(contractor)}
                      style={{
                        padding: '8px 12px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f0f0f0',
                        fontSize: '14px',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                      }}
                    >
                      {contractor.name}
                    </div>
                  ))}
                </div>
              )}
              {loadingContractors && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                  <CircularProgress size={20} />
                </Box>
              )}
            </div>
            
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Chip 
                label={`Поточна компанія: ${selectedUserForContractor?.contractor_name || 'не вказано'}`}
                color="primary"
                variant="outlined"
                sx={{ fontSize: '0.9rem', p: 1 }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">Скасувати</Button>
          <SaveButton onClick={handleContractorSave} variant="contained" startIcon={<SaveIcon />}>
            Змінити компанію
          </SaveButton>
        </DialogActions>
      </Dialog>

      {}
      <Dialog open={bulkActionDialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle sx={{ 
          bgcolor: bulkActionType === 'deactivate' ? '#ff9800' : '#4CAF50', 
          color: 'white' 
        }}>
          {bulkActionType === 'deactivate' ? (
            <>
              <BlockIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
              Вибіркова деактивація користувачів
            </>
          ) : (
            <>
              <RestoreIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
              Вибіркова активація користувачів
            </>
          )}
          <IconButton onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ py: 2 }}>
            <Typography variant="body1" gutterBottom>
              {bulkActionType === 'deactivate' 
                ? 'Оберіть користувачів для деактивації (відмітьте чекбоксами):' 
                : 'Оберіть користувачів для активації (відмітьте чекбоксами):'
              }
            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={bulkSelectAll}
                    onChange={handleBulkSelectAll}
                  />
                }
                label="Вибрати всіх"
              />
              <Typography variant="body2" color="text.secondary">
                Вибрано: {selectedUsers.length} з {bulkActionUsers.length}
              </Typography>
            </Box>
            
            <Paper sx={{ maxHeight: '300px', overflow: 'auto', border: '1px solid #e0e0e0' }}>
              <List>
                {bulkActionUsers.map((user, index) => {
                  const isSelected = selectedUsers.includes(user.id);
                  return (
                    <ListItem 
                      key={user.id} 
                      divider={index < bulkActionUsers.length - 1}
                      sx={{ 
                        backgroundColor: isSelected ? '#e3f2fd' : 'inherit',
                        '&:hover': { backgroundColor: '#f5f5f5' }
                      }}
                    >
                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleBulkSelectUser(user.id)}
                      />
                      <ListItemIcon>
                        <PersonIcon color={isSelected ? 'primary' : 'action'} />
                      </ListItemIcon>
                      <ListItemText 
                        primary={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body1" fontWeight={isSelected ? 'bold' : 'normal'}>
                              {user.username?.replace('_deactivated', '')}
                            </Typography>
                            {user.username?.includes('_deactivated') && (
                              <Chip label="Деактивовано" size="small" color="error" variant="outlined" />
                            )}
                          </Box>
                        }
                        secondary={
                          <Box component="span" sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', fontSize: '0.875rem' }}>
                            <span>Email: {user.email}</span>
                            <span>Телефон: {user.token || '-'}</span>
                            <span>Місто: {user.city || '-'}</span>
                            <span>Компанія: {user.contractor_name || '-'}</span>
                          </Box>
                        }
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
            
            <Typography variant="body2" color="error" sx={{ mt: 2 }}>
              {bulkActionType === 'deactivate' 
                ? 'Деактивовані користувачі не зможуть входити в систему.'
                : 'Активовані користувачі зможуть знову входити в систему.'}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="outlined">Скасувати</Button>
          <Button 
            onClick={handleBulkActionConfirm} 
            variant="contained" 
            color={bulkActionType === 'deactivate' ? 'warning' : 'success'}
            startIcon={bulkActionType === 'deactivate' ? <BlockIcon /> : <RestoreIcon />}
            disabled={selectedUsers.length === 0}
          >
            {bulkActionType === 'deactivate' 
              ? `Деактивувати ${selectedUsers.length} користувачів`
              : `Активувати ${selectedUsers.length} користувачів`
            }
          </Button>
        </DialogActions>
      </Dialog>

      {}
      <Dialog open={deactivateCompanyDialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: '#ff9800', color: 'white' }}>
          <WarningIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
          Деактивація всіх користувачів компанії
          <IconButton onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ py: 2 }}>
            <Typography variant="h6" gutterBottom>
              Компанія: <strong>{selectedContractor?.name}</strong>
            </Typography>
            <Typography variant="body1" color="error" gutterBottom>
              Ви збираєтесь деактивувати ВСІХ користувачів цієї компанії:
            </Typography>
            
            <List sx={{ bgcolor: '#fff3e0', borderRadius: 2, mt: 2 }}>
              {contractorUsers.map((user, index) => (
                <ListItem key={user.id} divider={index < contractorUsers.length - 1}>
                  <ListItemIcon>
                    <PersonIcon color="warning" />
                  </ListItemIcon>
                  <ListItemText 
                    primary={user.username?.replace('_deactivated', '')}
                    secondary={`Email: ${user.email} | Телефон: ${user.token || '-'} | Місто: ${user.city || '-'}`}
                  />
                </ListItem>
              ))}
            </List>
            
            <Typography variant="body2" color="error" sx={{ mt: 2 }}>
              Всі ці користувачі не зможуть входити в систему.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="outlined">Скасувати</Button>
          <DeactivateButton onClick={handleDeactivateCompanyConfirm} variant="contained" startIcon={<BlockIcon />}>
            Деактивувати всіх ({contractorUsers.length} користувачів)
          </DeactivateButton>
        </DialogActions>
      </Dialog>

      {}
      <Dialog open={deleteDialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Підтвердження видалення</DialogTitle>
        <DialogContent>
          <Typography>
            Ви дійсно хочете видалити користувача <strong>{selectedUser?.username?.replace('_deactivated', '')}</strong>?
          </Typography>
          <Typography variant="body2" color="error" sx={{ mt: 2 }}>
            Ця дія видалить користувача та всі пов'язані з ним дані. Дію неможливо скасувати!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Скасувати</Button>
          <DeleteButton onClick={handleDeleteConfirm} variant="contained">Видалити</DeleteButton>
        </DialogActions>
      </Dialog>
    </StyledContainer>
  );
};

export default UserManagement;
